import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../static/css/Service.css";
import service1 from "../static/img/service1.png";
import service2 from "../static/img/service2.jpeg";
import service3 from "../static/img/service3.jpeg";
import service4 from "../static/img/service4.jpeg";

function Services() {
  const services = [
    {
      img: service1,
      title: "Insolvency & Bankruptcy Service",
      description: "Comprehensive insolvency and restructuring services",
      details: [
        "Corporate Insolvency Resolution Process (CIRP)",
        "Liquidation Management",
        "Individual Insolvency Services (for personal guarantors)",
        "Bankruptcy Trustee Services (for personal guarantors)",
        "Going Concern Sales & Asset Realization",
        "Information Memorandum Preparation",
        "Resolution Plan / Repayment Plan Preparation",
        "IBC Consultation"
      ]
    },
    {
      img: service2,
      title: "Audit & Assurance",
      description: "Professional auditing and assurance services",
      details: [
        "Transaction Audits",
        "Forensic Audits",
        "Due Diligence Reviews",
        "Statutory Audits"
      ]
    },
    {
      img: service3,
      title: "Corporate Stress & Turnaround",
      description: "Strategic solutions for distressed businesses",
      details: [
        "Stressed Asset Rehabilitation",
        "Business Process Re-engineering",
        "Financial Restructuring",
        "Revival of Sick Units (Pre-IBC & IEC)",
        "OTS & CDR Scheme Facilitation"
      ]
    },
    {
      img: service4,
      title: "Financial Advisory",
      description: "Expert financial guidance and strategic planning",
      details: [
        "Mergers & Acquisitions (M&A)",
        "Corporate Restructuring",
        "Investor Identification & Coordination",
        "FDI Facilitation"
      ]
    }
  ];

  return (
    <>
      <div className="services-container">
        <div className="service-box">
          <div className="service-title">
            <h4>Our Services</h4>
          </div>
          <div className="service-list">
            {services.map((service, index) => {
              return (
                <div className="service-element" key={index}>
                  <img src={service.img} alt={service.title} />
                  <div className="service-element-content">
                    <p>{service.title}</p>
                    <span>{service.description}</span>
                    <Link to={`/services?service=${index}`}>
                      <button>Learn More</button>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
